const dashboard = () => import("../views/Dashboard.vue");
export default [
  {
    path: "dashboard",
    component: dashboard,
    meta: { requiresAuth: true, permissions: "dashboard"},
    name: "dashboard",
    props: true,
  },
];
